import { createAction } from 'redux-actions'
import * as constants from './constants'

export const setDocument = createAction(constants.SET_DOCUMENT)
export const setTitle = createAction(constants.SET_TITLE)

export const clearArticleErrors = createAction(constants.CLEAR_ARTICLE_ERRORS)

export const checkTitle = createAction(constants.CHECK_TITLE)
export const checkTitleSuccess = createAction(constants.CHECK_TITLE_SUCCESS)
export const checkTitleFailed = createAction(constants.CHECK_TITLE_FAILED)

export const checkSlug = createAction(constants.CHECK_SLUG)
export const checkSlugSuccess = createAction(constants.CHECK_SLUG_SUCCESS)
export const checkSlugFailed = createAction(constants.CHECK_SLUG_FAILED)

export const setSlug = createAction(constants.SET_SLUG)
export const setStatus = createAction(constants.SET_STATUS)

export const setArticle = createAction(constants.SET_ARTICLE)
export const clearArticle = createAction(constants.CLEAR_ARTICLE)

export const createArticle = createAction(constants.CREATE_ARTICLE)
export const createArticlePending = createAction(constants.CREATE_ARTICLE_PENDING)
export const createArticleSuccess = createAction(constants.CREATE_ARTICLE_SUCCESS)
export const createArticleFailed = createAction(constants.CREATE_ARTICLE_FAILED)

export const deleteArticle = createAction(constants.DELETE_ARTICLE)
export const deleteArticlePending = createAction(constants.DELETE_ARTICLE_PENDING)
export const deleteArticleSuccess = createAction(constants.DELETE_ARTICLE_SUCCESS)
export const deleteArticleFailed = createAction(constants.DELETE_ARTICLE_FAILED)

export const setArticleCategory = createAction(constants.SET_ARTICLE_CATEGORY)
export const setArticleSection = createAction(constants.SET_ARTICLE_SECTION)

export const createCategory = createAction(constants.CREATE_CATEGORY)
export const createCategoryPending = createAction(constants.CREATE_CATEGORY_PENDING)
export const createCategorySuccess = createAction(constants.CREATE_CATEGORY_SUCCESS)
export const createCategoryFailed = createAction(constants.CREATE_CATEGORY_FAILED)

export const editCategory = createAction(constants.EDIT_CATEGORY)
export const editCategoryPending = createAction(constants.EDIT_CATEGORY_PENDING)
export const editCategorySuccess = createAction(constants.EDIT_CATEGORY_SUCCESS)
export const editCategoryFailed = createAction(constants.EDIT_CATEGORY_FAILED)

export const deleteCategory = createAction(constants.DELETE_CATEGORY)
export const deleteCategoryPending = createAction(constants.DELETE_CATEGORY_PENDING)
export const deleteCategorySuccess = createAction(constants.DELETE_CATEGORY_SUCCESS)
export const deleteCategoryFailed = createAction(constants.DELETE_CATEGORY_FAILED)

export const changeCategoryName = createAction(constants.CHANGE_CATEGORY_NAME)
export const changeCategoryDescription = createAction(constants.CHANGE_CATEGORY_DESCRIPTION)

export const setCategory = createAction(constants.SET_CATEGORY)
export const clearCategory = createAction(constants.CLEAR_CATEGORY)

export const editArticle = createAction(constants.EDIT_ARTICLE)
export const editArticlePending = createAction(constants.EDIT_ARTICLE_PENDING)
export const editArticleSuccess = createAction(constants.EDIT_ARTICLE_SUCCESS)
export const editArticleFailed = createAction(constants.EDIT_ARTICLE_FAILED)

export const fetchArticle = createAction(constants.FETCH_ARTICLE)
export const fetchArticlePending = createAction(constants.FETCH_ARTICLE_PENDING)
export const fetchArticleSuccess = createAction(constants.FETCH_ARTICLE_SUCCESS)
export const fetchArticleFailed = createAction(constants.FETCH_ARTICLE_FAILED)

export const fetchCategories = createAction(constants.FETCH_CATEGORIES)
export const fetchCategoriesPending = createAction(constants.FETCH_CATEGORIES_PENDING)
export const fetchCategoriesSuccess = createAction(constants.FETCH_CATEGORIES_SUCCESS)
export const fetchCategoriesFailed = createAction(constants.FETCH_CATEGORIES_FAILED)

export const changeSectionName = createAction(constants.CHANGE_SECTION_NAME)
export const changeSectionDescription = createAction(constants.CHANGE_SECTION_DESCRIPTION)
export const changeSectionCategory = createAction(constants.CHANGE_SECTION_CATEGORY)

export const saveSectionEdits = createAction(constants.SAVE_SECTION_EDITS)
export const saveSectionEditsPending = createAction(constants.SAVE_SECTION_EDITS_PENDING)
export const saveSectionEditsSuccess = createAction(constants.SAVE_SECTION_EDITS_SUCCESS)
export const saveSectionEditsFailed = createAction(constants.SAVE_SECTION_EDITS_FAILED)

export const setSectionToEdit = createAction(constants.SET_SECTION_TO_EDIT)
export const clearSectionToEdit = createAction(constants.CLEAR_SECTION_TO_EDIT)

export const createSection = createAction(constants.CREATE_SECTION)
export const createSectionPending = createAction(constants.CREATE_SECTION_PENDING)
export const createSectionSuccess = createAction(constants.CREATE_SECTION_SUCCESS)
export const createSectionFailed = createAction(constants.CREATE_SECTION_FAILED)

export const deleteSection = createAction(constants.DELETE_SECTION)
export const deleteSectionPending = createAction(constants.DELETE_SECTION_PENDING)
export const deleteSectionSuccess = createAction(constants.DELETE_SECTION_SUCCESS)
export const deleteSectionFailed = createAction(constants.DELETE_SECTION_FAILED)

export const setSectionToDelete = createAction(constants.SET_SECTION_TO_DELETE)
export const clearSectionToDelete = createAction(constants.CLEAR_SECTION_TO_DELETE)

export const reorderCategories = createAction(constants.REORDER_CATEGORIES)
export const reorderCategoriesPending = createAction(constants.REORDER_CATEGORIES_PENDING)
export const reorderCategoriesSuccess = createAction(constants.REORDER_CATEGORIES_SUCCESS)
export const reorderCategoriesFailed = createAction(constants.REORDER_CATEGORIES_FAILED)

export const reorderCategoryDocuments = createAction(constants.REORDER_CATEGORY_DOCUMENTS)
export const reorderCategoryDocumentsPending = createAction(constants.REORDER_CATEGORY_DOCUMENTS_PENDING)
export const reorderCategoryDocumentsSuccess = createAction(constants.REORDER_CATEGORY_DOCUMENTS_SUCCESS)
export const reorderCategoryDocumentsFailed = createAction(constants.REORDER_CATEGORY_DOCUMENTS_FAILED)

export const reorderCategorySections = createAction(constants.REORDER_CATEGORY_SECTIONS)
export const reorderCategorySectionsPending = createAction(constants.REORDER_CATEGORY_SECTIONS_PENDING)
export const reorderCategorySectionsSuccess = createAction(constants.REORDER_CATEGORY_SECTIONS_SUCCESS)
export const reorderCategorySectionsFailed = createAction(constants.REORDER_CATEGORY_SECTIONS_FAILED)

export const reorderSectionDocuments = createAction(constants.REORDER_SECTION_DOCUMENTS)
export const reorderSectionDocumentsPending = createAction(constants.REORDER_SECTION_DOCUMENTS_PENDING)
export const reorderSectionDocumentsSuccess = createAction(constants.REORDER_SECTION_DOCUMENTS_SUCCESS)
export const reorderSectionDocumentsFailed = createAction(constants.REORDER_SECTION_DOCUMENTS_FAILED)